module.exports = __webpack_public_path__ + "media/images/circle-no-fb8e488aec9272b943a6ea282bb4282c.svg";